<template>
  <div>
    <center>
      <v-img height="100%" :src="imageHeadHRM"></v-img>
      <v-container fluid>
        <v-overlay :value="dataReady">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-row dense v-if="!dataReady">
          <v-col>
            <v-card>
              <v-img
                @click="Home()"
                :lazy-src="imageUrlBack"
                max-height="30"
                max-width="100"
                :src="imageUrlBack"
              ></v-img>

              <v-col cols="12">
                <v-sheet tile height="54" class="d-flex">
                  <v-select
                    v-model="month"
                    :items="monthNameTH"
                    dense
                    outlined
                    hide-details
                    label="เดือน"
                    class="ma-2"
                  ></v-select>
                  <v-select
                    v-model="year"
                    :items="yearsNumber"
                    dense
                    outlined
                    hide-details
                    label="ปี"
                    class="ma-2"
                  ></v-select>
                  <v-icon color="#871B12" size="30" @click="shift_import()"
                    >mdi-calendar-search</v-icon
                  >
                </v-sheet>
              </v-col>
            </v-card>
            <v-tabs v-model="tabs" fixed-tabs>
              <v-tabs-slider></v-tabs-slider>
              <v-tab href="#info" class="primary--text"> ข้อมูล </v-tab>

              <v-tab href="#summaryReport" class="primary--text">
                ภาพรวมประจำเดือน
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabs">
              <v-tab-item value="info">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr style="background-color: #1b437c">
                        <th class="text-center">วัน</th>
                        <th class="text-center">สถานที</th>
                        <th class="text-center">เข้างาน(ระยะ)</th>
                        <th class="text-center">เลิกงาน(ระยะ)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(items, index) in shifttem" :key="index">
                        <td>
                          {{ items.shiftDay }}
                        </td>
                        <td>
                          {{ items.location }}
                        </td>
                        <td>
                          <v-chip
                            class="ma-2"
                            :color="items.colorin"
                            text-color="white"
                          >
                            {{ items.checkInStartStamp }} ({{items.checkInDistance}})
                          </v-chip>
                        </td>
                        <td>
                          <v-chip
                            class="ma-2"
                            :color="items.colorout"
                            text-color="white"
                          >
                            {{ items.checkInEndStamp }} ({{items.checkOutDistance}})
                          </v-chip>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-tab-item>
              <v-tab-item value="summaryReport">
                <v-card>
                  <v-list dense>
                    <small>
                      <v-list-item>
                        <v-list-item-content
                          >จำนวนวันทำงาน:</v-list-item-content
                        >
                        <v-list-item-content class="align-end">
                          {{ dataReportMonth.Normal }} วัน
                        </v-list-item-content>
                      </v-list-item>

                      <v-list-item>
                        <v-list-item-content
                          >จำนวนวันที่เข้างานตามกะ:</v-list-item-content
                        >
                        <v-list-item-content class="align-end">
                          {{ dataReportMonth.Actual }} วัน
                        </v-list-item-content>
                      </v-list-item>

                      <v-list-item>
                        <v-list-item-content>รวมเวลาสาย:</v-list-item-content>
                        <v-list-item-content class="align-end">
                          {{ dataReportMonth.Late }} นาที
                        </v-list-item-content>
                      </v-list-item>

                      <v-list-item>
                        <v-list-item-content
                          >รวมเวลาออกงานก่อนเวลา:</v-list-item-content
                        >
                        <v-list-item-content class="align-end">
                          {{ dataReportMonth.Early }} นาที
                        </v-list-item-content>
                      </v-list-item>

                      <v-list-item>
                        <v-list-item-content>ไม่มี Check OUT:</v-list-item-content>
                        <v-list-item-content class="align-end">
                          {{ dataReportMonth.absent1 }} วัน
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>ไม่มี Check IN OUT:</v-list-item-content>
                        <v-list-item-content class="align-end">
                          {{ dataReportMonth.absent2 }} วัน
                        </v-list-item-content>
                      </v-list-item>
                    </small>
                  </v-list>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
            <p></p>
            <v-card>
              <v-img
                @click="Home()"
                :lazy-src="imageUrlBack"
                max-height="30"
                max-width="100"
                :src="imageUrlBack"
              ></v-img>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </center>
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
// moment().format('YYYY')
import monthNameTH from '../../assets/master/Date/monthNameTH.json'
import yearsNumber from '../../assets/master/Date/yearsNumber.json'
// import VuetifyLogo from '../logo'
export default {
  components: {
    // VuetifyLogo
  },
  name: 'Info',
  beforeCreate () {
    // this.$liff.init({ liffId: this.$liff_info }, function (data) {})
  },
  data () {
    return {
      imageUrlBack: '',
      imageHeadHRM: '',
      shifttem: [],
      dataReportMonth: [],
      year: '',
      month: '',
      day: '',
      dadataReadyy: true,
      monthNameTH: monthNameTH,
      yearsNumber: yearsNumber,
      tabs: 'tabInfo'
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    // this.profile = JSON.parse(localStorage.getItem('liff_info'))
    this.imageUrlBack = require('@/assets/Icon/Back.jpg')
    this.imageHeadHRM = require('@/assets/Icon/HRM.jpg')

    // if (JSON.parse(localStorage.getItem('liff_info'))) {
    //   this.Home()
    // } else {
    await this.shift_import()
    await this.getReportCheckIN()
    // }
  },
  methods: {
    Home () {
      this.$router.push('/Liff/Home')
    },
    async shift_import () {
      // const today = new Date()
      this.dataReady = true

      this.month = this.month !== '' ? this.month : this.getMonthTh()
      this.year = this.year !== '' ? this.year : moment().format('YYYY')

      this.shifttem = []

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
              '/shift_import/getEmpCodeShiftMonth?empCode=' +
              JSON.parse(localStorage.getItem('liff_info')).empCode +
              '&shiftMonth=' +
              this.getMonthThToINT(this.month) +
              '&shiftYear=' +
              this.year
        )
        .then(async (response) => {
          this.shifttem = response.data
          this.shifttem.forEach((shifttem) => {
            if (shifttem.checkInStartStamp) {
              // var date =
              //   shifttem.checkInYear +
              //   '-' +
              //   shifttem.checkInMonth +
              //   '-' +
              //   shifttem.checkInDay
              // var startStamp = new Date(
              //   date + ' ' + shifttem.checkInStartStamp
              // )
              // var masShiftTypeStartTime = new Date(
              //   date + ' ' + shifttem.masShiftTypeStartTime
              // )

              // var checkInStartStampArray = shifttem.checkInStartStamp.split(':')
              // shifttem.checkInStartStamp = checkInStartStampArray[0].toString().padStart(2, 0) + ':' + checkInStartStampArray[1].toString().padStart(2, 0)
              shifttem.colorout = 'green'

              if (!shifttem.checkInEndStamp) {
                shifttem.checkInEndStamp = 'ไม่พบข้อมูล'
                shifttem.colorout = '-'
              }

              if (shifttem.lateStatus === 'ปกติ') {
                shifttem.detail = 'ปกติ'
                shifttem.colorin = 'green'
              }

              if (shifttem.lateStatus === 'สาย') {
                shifttem.colorin = 'red'
                shifttem.detail = 'สาย'
              }

              if (shifttem.shiftCode === 'H') {
                shifttem.detail = 'วันหยุด'
              }
              if (shifttem.leave !== null) {
                shifttem.detail = shifttem.leave
                shifttem.checkInStartStamp = (shifttem.leaveSummaryDayName === 'ครึ่งวันเช้า' || shifttem.leaveSummaryDayName === 'เต็มวัน') ? shifttem.leave : shifttem.checkInStartStamp
                shifttem.checkInEndStamp = (shifttem.leaveSummaryDayName === 'ครึ่งวันบ่าย' || shifttem.leaveSummaryDayName === 'เต็มวัน') ? shifttem.leave : shifttem.checkInEndStamp
                shifttem.colorin = (shifttem.leaveSummaryDayName === 'ครึ่งวันเช้า' || shifttem.leaveSummaryDayName === 'เต็มวัน') ? 'blue' : shifttem.colorin
                shifttem.colorout = (shifttem.leaveSummaryDayName === 'ครึ่งวันบ่าย' || shifttem.leaveSummaryDayName === 'เต็มวัน') ? 'blue' : shifttem.colorout
              }
            } else {
              if (shifttem.shiftCode === 'H') {
                shifttem.checkInStartStamp = 'วันหยุด'
                shifttem.checkInEndStamp = 'วันหยุด'
                shifttem.detail = 'วันหยุด'
                shifttem.colorin = 'black'
                shifttem.colorout = 'black'
              } else {
                console.log(shifttem.shiftDay, shifttem.leave, shifttem.leaveSummaryDayName)
                if (shifttem.leave !== null) {
                  shifttem.detail = shifttem.leave
                  shifttem.checkInStartStamp = (shifttem.leaveSummaryDayName === 'ครึ่งวันเช้า' || shifttem.leaveSummaryDayName === 'เต็มวัน') ? shifttem.leave : 'ไม่พบข้อมูล'
                  shifttem.checkInEndStamp = (shifttem.leaveSummaryDayName === 'ครึ่งวันบ่าย' || shifttem.leaveSummaryDayName === 'เต็มวัน') ? shifttem.leave : 'ไม่พบข้อมูล'
                  shifttem.colorin = (shifttem.leaveSummaryDayName === 'ครึ่งวันเช้า' || shifttem.leaveSummaryDayName === 'เต็มวัน') ? 'blue' : '-'
                  shifttem.colorout = (shifttem.leaveSummaryDayName === 'ครึ่งวันบ่าย' || shifttem.leaveSummaryDayName === 'เต็มวัน') ? 'blue' : '-'
                } else {
                  shifttem.checkInStartStamp = 'ไม่พบข้อมูล'
                  shifttem.checkInEndStamp = 'ไม่พบข้อมูล'
                  shifttem.detail = 'ไม่พบข้อมูล'
                  shifttem.colorin = '-'
                  shifttem.colorout = '-'
                }
              }
            }
            this.dataReady = false
          })
          // console.log('shifttem', this.shifttem)
          this.shifttem = this.shifttem
            .slice()
            .sort((a, b) => a.shiftDay - b.shiftDay)
            // console.log(this.shifttem)
        })
      // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = false
        })
    },
    async getReportCheckIN () {
      this.dataReportMonth = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
              '/shift_import/reportMonthEmpCode?shiftMonth=' +
              this.getMonthThToINT(this.month) +
              '&shiftYear=' +
              this.year +
              '&empCode=' +
              JSON.parse(localStorage.getItem('liff_info')).empCode,
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          // console.log('getReportCheckIN', response.data)
          this.dataReportMonth = response.data
        })
      // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReportMonth = []
          console.log(error)
        })
    }
  }
}
</script>
<style scoped>
.table-header {
  background-color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/Liff/CheckinHistory.vue